import {
  CONFIRMED_GET_PATHYA,
  CONFIRMED_CREATE_PATHYA,
  CONFIRMED_EDIT_PATHYA,
  CONFIRMED_DELETE_PATHYA,
} from "../types/PathyaTypes"

import {
  getPathyaList,
  createPathya,
  updatePathya,
  deletePathya,
} from "../../services/PathyaService"

import {
  handleSuccess,
  showErrorAlert,
} from "../../services/ErrorHandlingService"


export function getPathyaAction( pagination = true,
  pageid = 0,
  search_by = "",
  search_keyword = "",
  sort_by = "",
  sort_order = "") {
  return async (dispatch) => {
    try {
      const response = await getPathyaList( pagination,
        pageid,
        search_by,
        search_keyword,
        sort_by,
        sort_order)

      if (response?.status === 200 && response.data?.status === "success") {
        dispatch({
          type: CONFIRMED_GET_PATHYA,
          payload: {
            list: response.data.data,        // ✅ actual page data
            num_rows: response.data.num_rows // ✅ total count (42)
          },
        })
      } else {
        showErrorAlert("Failed to fetch Pathyas", "error")
      }
    } catch (error) {
      console.error(error)
      showErrorAlert("Something went wrong", "error")
    }
  }
}


export function createPathyaAction(formData, navigate) {
  return async (dispatch) => {
    try {
      const response = await createPathya(formData);

      if (response?.status === 200 && response.data?.status === "success") {
        dispatch({
          type: CONFIRMED_CREATE_PATHYA,
          payload: response.data.data,
        });

        handleSuccess("Pathya added successfully!", "success");
        if (navigate) navigate("/pathyas");
      } else {
        showErrorAlert("Failed to add Pathya", "error");
      }

      return response; // 🔥 IMPORTANT
    } catch (error) {
      console.error(error);
      showErrorAlert("Failed to add Pathya", "error");
      throw error; // 🔥 IMPORTANT
    }
  };
}


export function updatePathyaAction(formData, navigate) {
  return async (dispatch) => {
    try {
      const response = await updatePathya(formData);

      if (response?.status === 200 && response.data?.status === "success") {
        dispatch({
          type: CONFIRMED_EDIT_PATHYA,
          payload: response.data.data,
        });

        handleSuccess("Pathya updated successfully!", "success");
        if (navigate) navigate("/pathyas");
      } else {
        showErrorAlert("Failed to update Pathya", "error");
      }

      return response; // 🔥 IMPORTANT
    } catch (error) {
      console.error(error);
      showErrorAlert("Failed to update Pathya", "error");
      throw error; // 🔥 IMPORTANT
    }
  };
}



export function deletePathyaAction(pathya_id) {
  return async (dispatch) => {
    try {
      await deletePathya(pathya_id)

      dispatch({
        type: CONFIRMED_DELETE_PATHYA,
        payload: { pathya_id },
      });

      handleSuccess("Pathya deleted successfully!", "success");
    } catch (error) {
      showErrorAlert("Failed to delete Pathya", "error");
    }
  };
}
